<!--
 * @Author: zZZz
 * @Date: 2026-07-07 17:02:32
 * @LastEditTime: 2026-07-07 17:21:57
 * @LastEditors: zZZz
 * @Description: 
 * @FilePath: \procure-saas-portal\src\components\TianAiCaptcha\index.vue
-->
<template>
    <div class="tianai-captcha-mask">
        <div class="tianai-captcha-wrapper" ref="captchaRoot"></div>
    </div>
</template>

<script>
export default {
    name: "TianAiCaptcha",
    mounted() {
        this.$nextTick(() => {
            this.initCaptcha();
        });
    },
    beforeDestroy() {
        this.destroyCaptcha();
    },
    methods: {
        initCaptcha() {
            if (typeof window.TAC !== "function") {
                this.$message.error("TIANAI 验证组件未加载，请检查网络或刷新页面");
                return;
            }
            this.destroyCaptcha();
            const config = {
                bindEl: this.$refs.captchaRoot,
                requestCaptchaDataUrl: process.env.VUE_APP_BASE_API + "/captcha/slide/captcha/get",
                validCaptchaUrl: process.env.VUE_APP_BASE_API + "/captcha/slide/captcha/check",
                requestHeaders: {
                    "Content-Type": "application/json;charset=UTF-8",
                },
                btnCloseFun: () => {
                    this.handleClose();
                },
                validSuccess: (res) => {
                    const data = (res && res.data) || {};
                    if (data.uuid && data.code) {
                        this.$emit("success", data);
                    } else {
                        this.$message.error("滑块验证成功但返回参数异常，请重试");
                    }
                    this.destroyCaptcha();
                },
                validFail: () => {
                    this.$message.error("滑块验证失败，请重试");
                    // 失败后重新初始化滑块，方便用户重试
                    setTimeout(() => {
                        try {
                            this.initCaptcha();
                        } catch (e) {
                            // 如果重复初始化出错，先销毁，延迟后再试一次
                            this.destroyCaptcha();
                            setTimeout(() => this.initCaptcha(), 300);
                        }
                    }, 300);
                },
            };
            this.captchaInstance = new window.TAC(config, {});
            this.captchaInstance.init();
        },
        destroyCaptcha() {
            if (this.captchaInstance && typeof this.captchaInstance.destroyWindow === "function") {
                this.captchaInstance.destroyWindow();
            }
            this.captchaInstance = null;
        },
        handleClose() {
            this.destroyCaptcha();
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.tianai-captcha-mask {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.35);
    z-index: 9999;
}

.tianai-captcha-wrapper {
    /*width: 460px; */
    max-width: 92%;
    background: transparent;
}
</style>
